import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'slugify' })
export class SlugifyPipe implements PipeTransform {
  transform(input: string): string {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
    const p = new RegExp(a.split('').join('|'), 'g');

    return input ? input.toString() // .toLowerCase()
      // Strip diacritics uniformly for BOTH cases (É À Ç… as well as é à ç…). The `a`/`b` table
      // below only listed lowercase accents, so uppercase-accented input was dropped by the ASCII
      // `\w` filter below. NFD decomposes a precomposed letter into base + combining mark, removed
      // here; the table still handles the non-decomposable letters it covers (æ ø ß ł đ œ…).
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with 'and'
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '')  // Trim - from end of text
    : null;
  }
}
